import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import AuthPage from './AuthPage';
import NinjaCreamiApp from './ninja-creami-calculator';
import PaymentSuccess from './PaymentSuccess';

function App() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  // בדיקה אם זה דף payment-success
  if (window.location.pathname === '/payment-success') {
    return <PaymentSuccess />;
  }

  if (!session) {
    return <AuthPage />;
  }

  return (
    <div>
      <button 
        onClick={() => supabase.auth.signOut()} 
        style={{ position: 'absolute', top: '10px', left: '10px', padding: '5px 10px' }}
      >
        התנתק
      </button>
      <NinjaCreamiApp />
    </div>
  );
}

export default App;